import React, { useEffect, useState } from "react"
import { Row, Form, Table, Modal } from "reactstrap"
import Select from "react-select"
import Loader from "pages/Separate/Loader"
import configure from "configure"
import axios from "axios"
import Swal from "sweetalert2"
import secureLocalStorage from "react-secure-storage"
import DocumentApproval from "../ApprovalItems/ApprovalDocuments"
import placeholderImage from "../../../assets/images/uploadFileImg.jpg"
import { getInitials } from "utils/common-helpers"

const Documents = ({ id, verticalActiveTab, apporveStatus }) => {
  const [isLoading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [file, setFile] = useState(null)
  const [requirementType, setRequirementType] = useState("")
  const [name, setName] = useState("")

  // Edit Document Integration
  const [editDocument, setEditDocument] = useState("")
  const [editDocumentName, setEditDocumentName] = useState("")
  const [editDocumentType, setEditDocumentType] = useState(null)
  const [editDocumentImg, setEditDocumentImg] = useState("")
  const [docId, setDocId] = useState("")

  const docType = [
    { label: "Enrolling Documents", value: "Enrolling Documents" },
    { label: "Zithas Documents", value: "Zithas Documents" },
  ]

  const handleSubmit = async e => {
    e.preventDefault()
    const bearerToken = secureLocalStorage.getItem("auth_token")
    if (requirementType !== "") {
      setLoading(true)
      const formData = new FormData()
      formData.append("staff_id", id)
      formData.append("file", file)
      formData.append("requirement_type", requirementType?.value)
      formData.append("name", name)
      try {
        const response = await axios({
          method: "post",
          url: `${configure.nodeApi}/addStaffDocument`,
          data: formData,
          headers: {
            Authorization: "Bearer " + bearerToken,
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        })
        if (response) {
          const modifyArray = response?.data?.data?.filter(item => {
            const type = ["enrollingdocuments", "zithasdocuments"]
            const itemtypes = item.requirement_type
              ?.replace(/\s+/g, "")
              .toLowerCase()
            return type.includes(itemtypes)
          })
          setLoading(false)
          setName("")
          setRequirementType([])
          setFile("")
          Swal.fire({
            icon: "success",
            text: "Staff documents details added successfully",
          }).then(() => {
            setData(modifyArray)
          })
        }
      } catch (err) {
        setLoading(false)
        console.log(err)
      }
    } else {
      Swal.fire({
        icon: "warning",
        text: "Please select all mandatory fields",
      })
    }
  }
  const getDocuments = async () => {
    setLoading(true)
    const formData = new FormData()
    formData.append("staff_id", id)
    const bearerToken = secureLocalStorage.getItem("auth_token")
    try {
      const response = await axios({
        method: "get",
        url: `${configure.nodeApi}/employeeJoining/showStaffDocument/${id}`,
        data: formData,
        headers: {
          Authorization: "Bearer " + bearerToken,
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then(response => {
        const modifyArray = response?.data?.data?.filter(item => {
          const type = ["enrollingdocuments", "zithasdocuments"]
          const itemtypes = item.requirement_type
            ?.replace(/\s+/g, "")
            .toLowerCase()
          return type.includes(itemtypes)
        })
        setData(modifyArray)
        setLoading(false)
      })
    } catch (err) {
      console.log(err)
      setLoading(false)
    }
  }
  useEffect(() => {
    if (verticalActiveTab == "tab5") {
      if (data?.length == 0) {
        getDocuments()
      }
    }
  }, [verticalActiveTab])

  const deleteDocument = fileId => {
    Swal.fire({
      icon: "warning",
      title: "Are you sure ?",
      text: "You want to delete document.",
      showCancelButton: true,
    }).then(async willOkay => {
      if (willOkay.isConfirmed) {
        setLoading(true)
        const formData = new FormData()
        formData.append("staff_id", id)
        formData.append("file_id", fileId)
        try {
          const response = await axios({
            method: "post",
            url: `${configure.nodeApi}/deleteStaffDocument`,
            data: formData,
            headers: {
              Accept: "application/json",
              "Content-Type": "multipart/form-data",
            },
          })
          if (response) {
            setLoading(false)
            Swal.fire({
              icon: "success",
              text: "Document deleted successfully !",
            }).then(() => {
              const modifyArray = response?.data?.data?.filter(item => {
                const type = ["enrollingdocuments", "zithasdocuments"]
                const itemtypes = item.requirement_type
                  ?.replace(/\s+/g, "")
                  .toLowerCase()
                return type.includes(itemtypes)
              })
              setData(modifyArray)
            })
          }
        } catch (error) {
          setLoading(false)
          console.log(error)
        }
      }
    })
  }
  const EditDocument = ob => {
    setDocId(ob.id)
    setEditDocumentName(ob.file_name)
    const type = {
      value: ob.requirement_type,
      label: ob.requirement_type,
    }
    setEditDocumentType(type)
    setEditDocument(true)
  }
  const handleEditDoc = async e => {
    e.preventDefault()
    if (editDocumentType !== null) {
      setLoading(true)
      const formData = new FormData()
      formData.append("staff_id", id)
      formData.append("file_id", docId)
      if (editDocumentImg) {
        formData.append("file", editDocumentImg)
      }
      formData.append("requirement_type", editDocumentType.value)
      formData.append("name", editDocumentName)

      try {
        const response = await axios({
          method: "post",
          url: `${configure.nodeApi}/editStaffDocument`,
          data: formData,
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        })
        if (response) {
          setLoading(false)
          setEditDocumentImg("")
          setEditDocumentType(null)
          setEditDocumentName("")
          Swal.fire({
            icon: "success",
            text: "Document edited successfully !",
          }).then(() => {
            setEditDocument(false)
            const modifyArray = response?.data?.data?.filter(item => {
              const type = ["enrollingdocuments", "zithasdocuments"]
              const itemtypes = item.requirement_type
                ?.replace(/\s+/g, "")
                .toLowerCase()
              return type.includes(itemtypes)
            })
            setData(modifyArray)
          })
        }
      } catch (error) {
        setLoading(false)
        console.log(error)
      }
    } else {
      Swal.fire({
        icon: "warning",
        text: "Please select all mandatory fields",
      })
    }
  }

  return (
    <>
      {isLoading && <Loader />}
      <div>
        <form onSubmit={handleSubmit}>
          <div className=" p-4 bg-white shadow">
            <Row>
              <div className="col-md-5">
                <div className="d-flex justify-content-between">
                  <h5 className="text-dark mb-3">Document Upload</h5>

                  <button className=" btn text-white  me-2 btn-save btn-label">
                    <i className="bi bi-cloud-arrow-up me-2 label-icon"></i>
                    Upload
                  </button>
                </div>

                <div className="mb-4">
                  <label htmlFor="type">
                    Document Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control "
                    id="type"
                    required
                    placeholder="Enter Document Name"
                    value={name}
                    onChange={e => setName(e.target.value)}
                  />
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-4">
                      <label htmlFor="type">
                        Document Type <span className="text-danger">*</span>
                      </label>
                      <Select
                        placeholder="Select Document Type"
                        className="basic-multi-select "
                        classNamePrefix="select"
                        options={docType}
                        value={requirementType}
                        onChange={e => setRequirementType(e)}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div>
                      <label htmlFor="">
                        Upload Document <span className="text-danger">*</span>
                      </label>
                      <input
                        type="file"
                        className="form-control "
                        id="document"
                        required
                        onChange={e => setFile(e.target.files[0])}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-7 ps-5">
                {apporveStatus == 0 || apporveStatus == 2 ? (
                  <DocumentApproval
                    user_id={id}
                    fetchDocuments={getDocuments}
                  />
                ) : (
                  <div className="text-center">
                    <img
                      src={placeholderImage}
                      className="img-fluid w-75"
                      alt=""
                    />
                  </div>
                )}
              </div>
            </Row>

            <div className="mt-4 bg-white">
              <Row>
                <div className="col-12">
                  <Table className="table table-striped table-bordered table-hover shadow">
                    <thead>
                      <tr>
                        <th className="col-1 text-center">Sr.No</th>
                        <th className="col-3">Document Name</th>
                        <th>Document Type</th>
                        <th className="text-center">Uploaded By</th>
                        <th className="text-center">Approved By</th>
                        <th className="text-center">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.map((ob, index) => {

                        return (
                          <tr key={index}>
                            <td className="text-center">{index + 1}</td>
                            <td>{ob.file_name}</td>
                            <td>{ob.requirement_type}</td>
                            <td className="text-center">
                              <div className="d-flex justify-content-center gap-2 align-items-center">
                                {ob.uploaded_by_details?.avatar ? (
                                  <img
                                    src={`${configure.imgUrl}${ob.uploaded_by_details?.avatar}`}
                                    alt="Avatar"
                                    title={ob.uploaded_by_details?.name} // tooltip for hover
                                    className="img-fluid rounded-circle"
                                    width={22}
                                    height={22}
                                  />
                                ) : (
                                  <div
                                    className="defualt-img rounded-circle d-flex align-items-center justify-content-center"
                                    title={ob.uploaded_by_details?.name}
                                    style={{
                                      width: 22,
                                      height: 22,
                                      fontSize: 10,
                                    }}
                                  >
                                    {getInitials(ob.uploaded_by_details?.name)}
                                  </div>
                                )}
                                {ob.uploaded_by_details?.name || "N/A"}

                              </div>
                            </td>
                            <td className="text-center">
                              <div className="d-flex justify-content-center gap-2 align-items-center">
                                {ob.approved_by_details?.avatar ? (
                                  <img
                                    src={`${configure.imgUrl}${ob.approved_by_details?.avatar}`}
                                    alt="Avatar"
                                    title={ob.approved_by_details?.name} // tooltip for hover
                                    className="img-fluid rounded-circle"
                                    width={22}
                                    height={22}
                                  />
                                ) : (
                                  <div
                                    className="defualt-img rounded-circle d-flex align-items-center justify-content-center"
                                    title={ob.approved_by_details?.name}
                                    style={{
                                      width: 22,
                                      height: 22,
                                      fontSize: 10,
                                    }}
                                  >
                                    {getInitials(ob.approved_by_details?.name)}
                                  </div>
                                )}
                                {ob.approved_by_details?.name || "N/A"}

                              </div>
                            </td>
                            <td className="text-center">
                              <button
                                type="button"
                                className="btn btn-sm me-1 btn-outline-secondary"
                                // onClick={() => deleteDocument(ob.id)}
                                onClick={() => {
                                  EditDocument(ob)
                                }}
                                title="Edit Document"
                              >
                                <i className="fas fa-pen"></i>
                              </button>
                              <a
                                // type="button"
                                href={ob.link}
                                target="_blank"
                                className="btn btn-sm me-1 btn-outline-secondary"
                                // onClick={() => downloadImage(ob.link)}
                                title="Download Document"
                                rel="noreferrer"
                              >
                                <i className="fa fa-eye"></i>
                              </a>
                              <button
                                type="button"
                                className="btn btn-sm  btn-outline-danger"
                                onClick={() => deleteDocument(ob.id)}
                                title="Delete Document"
                              >
                                <i className="fas fa-trash-alt"></i>
                              </button>
                            </td>
                          </tr>
                        )
                      })}
                      {data.length == 0 && (
                        <tr>
                          <td colSpan={8} className="text-center">
                            {" "}
                            No Document Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </Row>
            </div>
          </div>
        </form>
      </div>

      {/* Edit Documents  */}
      <Modal isOpen={editDocument} size="lg" className="" centered>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Edit Document</h5>
          <button
            type="button"
            onClick={() => {
              setEditDocument(false)
            }}
            className="btn-modal-close"
          >
            <span aria-hidden="true" className="btn-modal-span">
              &times;
            </span>
          </button>
        </div>
        <div className="modal-body">
          <Form onSubmit={handleEditDoc}>
            <div className="row">
              <div className="col-md-4 mb-4">
                <label htmlFor="type">
                  Document Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control "
                  id="type"
                  required
                  placeholder="Enter Document Name"
                  value={editDocumentName}
                  onChange={e => setEditDocumentName(e.target.value)}
                />
              </div>
              <div className="col-md-4 mb-4">
                <label htmlFor="type">
                  Document Type <span className="text-danger">*</span>
                </label>
                <Select
                  value={editDocumentType}
                  placeholder="Select Document Type"
                  className="basic-multi-select "
                  classNamePrefix="select"
                  options={docType}
                  onChange={e => setEditDocumentType(e)}
                />
              </div>
              <div className="col-md-4 mb-4 ">
                <div className="row">
                  <label htmlFor="">Upload Document</label>
                </div>
                <input
                  type="file"
                  className="form-control "
                  id="document"
                  onChange={e => setEditDocumentImg(e.target.files[0])}
                />
              </div>
              <div className="col-md-4 mb-3 ">
                <button className=" btn text-white  me-2 btn-save btn-label">
                  <i className="bi bi-cloud-arrow-up me-2 label-icon"></i>Upload
                </button>
              </div>
            </div>
          </Form>
        </div>
      </Modal>
    </>
  )
}

export default Documents
